import '../polyfills'
import widgets from './widgets'
/* eslint-disable no-unused-vars */
const VybEvents = widgets
if (window) {
  window.VybEvents = widgets
}
